export default {
  'resetpassword.maintext':
    'لإعادة تعيين كلمة المرور الخاصة بك، يرجى إدخال كلمة المرور الجديدة في كلا الحقلين.',
  'resetpassword.retypepassword': 'إعادة إدخال كلمة المرور',
};
